<style>
  .campaign-modal {
    margin: auto;
  }

  @media screen and (min-width: 1910px) and (max-width: 1920px) {
    .campaign-modal {
      width: 750px !important;
    }
  }

  @media (min-width: 768px) {
    .campaign-modal {
      width: 600px;
      margin: 30px auto;
    }
  }
</style>

<template>
  <div>
    <Logo page="home" />
    <div class="container-fluid bg-3 text-center">
      <div class="block_container drop">
        <div
          v-for="index in 220"
          :key="index"
          :class="`block block_${index}`"
        />
        <div class="clearfix" />
      </div>
    </div>
    <Menu />
    <!-- <marquee-text :duration="40" :repeat="2" :paused="isPaused">
         <ul>
             <li v-for="(item, key) in dataEvents" :key="key" @click="get_steps_event_details(item.events_id)" @mouseover="scrollHover" @mouseout="scrollOut">
                 <a href="javascript:;">
                     <img :src="`${IMAGEURL}thumb/${item.image}`" alt="Event Image">
                 </a>
             </li>
         </ul>
     </marquee-text>-->
    <div
      id="pageModal"
      class="modal fade"
      role="dialog"
    >
      <div class="modal-dialog">
        <div class="modal-content pageModalContent">
          <div class="modal-header noHeaderModal">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
            >
              &times;
            </button>
            <h4 class="modal-title" />
          </div>
          <div class="modal-body">
            <!------------------events------------------------>
            <div
              v-if="modalData.type == 'eventDetails'"
              style="position: relative;"
            >
              <div class="col-sm-12">
                <div class="news_title">
                  {{ modalData.title }}
                </div>
                <div class="text-center mt10">
                  <a
                    v-if="modalData.image_type == 'external'"
                    href="#"
                    class="example-image-link"
                    data-lightbox="example-1"
                  >
                    <span class="roll" />
                    <img
                      :src="`${modalData.image_type}`"
                      alt="News Image"
                      class="responsive radius example-image"
                    >
                  </a>
                  <a
                    v-else
                    href="#"
                    class="example-image-link"
                    data-lightbox="example-1"
                  >
                    <span class="roll" />
                    <img
                      :src="`${IMAGEURL}${modalData.image}`"
                      alt="News Image"
                      class="responsive radius example-image"
                    >
                  </a>
                </div>
                <div
                  class="text-justify"
                  v-html="modalData.description"
                />
              </div>
              <div class="clearfix" />
            </div>
            <!------------------end events------------------------>
          </div>
          <div class="clearfix" />
        </div>
      </div>
    </div>
    <input
      class="blockWidth"
      type="hidden"
      value="95"
    >
<!--    <div
      id="campaign"
      class="modal fade"
      role="dialog"
      style="    display: none;
    position: absolute;
    left: 0;
    width: auto;
    top: 10%;
    right: 0;
    transform: none !important;
    bottom: 0;
    margin: auto;
    overflow: hidden;"
    >
      <div class="modal-dialog campaign-modal">
        &lt;!&ndash; Modal content&ndash;&gt;
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
            >
              &times;
            </button>
            <h4 class="modal-title">
              Make a Donation Today
            </h4>
          </div>
          <div
            class="modal-body"
            style="padding: 0px"
          >
            <a :href="`${baseUrl}campaign`">
              <img
                src="http://thesteps.org/admin/public/upload/cms/eid-campaign-22.jpg"
                alt=""
                style="height: auto; max-width: 100%"
              >
            </a>
          </div>
        </div>
      </div>
    </div>-->
  </div>
</template>

<script>
  import Menu from './Menu.vue';
  import Logo from './Logo.vue';

  export default {
    components: {
      Menu,
      Logo,
    },
    data() {
      return {
        blockWidth: 95,
        blockHeight: 95,
        dataEvents: [],
        modalData: {},
        isPaused: false,
      };
    },
    mounted() {
      this.block_calculation();
      const that = this;
      window.addEventListener(`resize`, function () {
        const width = $(window)
          .width();
        that.resize_block(width, this.blockWidth);
        if (width > 800) {
          location.reload();
        }
      });
      $(`#campaign`)
        .modal(`show`);
    },
    methods: {
      scrollHover() {
        this.isPaused = true;
      },
      scrollOut() {
        this.isPaused = false;
      },
      getEvents() {
        this.$http.get(`getAllEvents`)
          .then((response) => {
            this.dataEvents = response.data;
          })
          .catch((error) => {
            if (error.response.status) {
              this.dataEvents = [];
            }
          });
      },
      get_steps_event_details(id) {
        $(`#loading`)
          .show();
        const formData = {
          id,
        };
        this.$http.post(`getEventDetails`, formData)
          .then((response) => {
            this.modalData = response.data;
            this.modalData.type = `eventDetails`;
            $(`#pageModal`)
              .modal(`show`);
            $(`#loading`)
              .hide();
          })
          .catch((error) => {
            if (error.response.status) {
              this.modalData = {};
            }
          });
      },
      set_html(array, total, menuStart) {
        for (let i = 0; i < total; i++) {
          const menuNo = i + menuStart;
          const html = $(`.menu${menuNo}`)
            .html();
          $(`.block_${array[i]}`)
            .html(html);
        }
      },
      resize_block(width, blockWidth) {
        let screenWidth = 0;
        let blockCount = 0;
        let newBlockSize = 0;
        screenWidth = width - 10;
        blockCount = screenWidth / blockWidth;
        blockCount = Math.round(blockCount);
        newBlockSize = screenWidth / blockCount;
        newBlockSize -= 0.25;
        $(`.block`)
          .css({ width: newBlockSize });
        this.blockWidth = newBlockSize;
        $(`.blockWidth`)
          .val(newBlockSize);

        const height = $(window)
          .height();
        if (height >= 1025) {
          $(`.block_container`)
            .css({ height: `${height}px` });
        }
      },
      block_calculation() {
        const width = $(window)
          .width();
        const height = $(window)
          .height();
        this.resize_block(width, this.blockWidth);

        // no of block in horizontal screen
        let horizontalBlock = parseInt((width - 10) / this.blockWidth);
        if (width % this.blockWidth == 10) {
          horizontalBlock = parseInt(width / this.blockWidth);
        }

        // no of block in vertical screen
        const verticalBlock = parseInt(height / this.blockHeight);
        const total_block = horizontalBlock * verticalBlock;
        // console.log(total_block);
        $(`.block`)
          .html(``);

        // check screen width
        let first_series = [];
        let second_series = [];
        let third_series = [];
        let fourth_series = [];

        if ((width < 295) || (width > 1920)) {
          total_menu = 14;

          const numbers = [];
          while (numbers.length < total_menu) {
            const randomnumber = Math.ceil(Math.random() * total_block);
            if (numbers.indexOf(randomnumber) > -1) continue;
            numbers[numbers.length] = randomnumber;
          }

          for (let i = 0; i < total_menu; i++) {
            html = $(`.menu${i}`)
              .html();
            $(`.block_${numbers[i]}`)
              .html(html);
          }
        } else if ((width >= 1910) && (width <= 1920)) {
            first_series = [27, 29, 31, 33];
            second_series = this.getSeries(1900, 2, 3);
            third_series = this.getSeries(1900, 3, 3);
            fourth_series = this.getSeries(1900, 4, 3);

            this.set_html(first_series, 4, 0);
            this.set_html(second_series, 3, 4);
            this.set_html(third_series, 3, 7);
            this.set_html(fourth_series, 3, 10);
          } else if ((width >= 1863) && (width < 1910)) {
            first_series = [27, 29, 31, 33];
            second_series = this.getSeries(1863, 2, 3);
            third_series = this.getSeries(1863, 3, 3);
            fourth_series = this.getSeries(1863, 4, 3);

            this.set_html(first_series, 4, 0);
            this.set_html(second_series, 3, 4);
            this.set_html(third_series, 3, 7);
            this.set_html(fourth_series, 3, 10);
          } else if ((width >= 1815) && (width < 1863)) {
            first_series = [26, 28, 30, 32];
            second_series = this.getSeries(1815, 2, 3);
            third_series = this.getSeries(1815, 3, 3);
            fourth_series = this.getSeries(1815, 4, 3);

            this.set_html(first_series, 4, 0);
            this.set_html(second_series, 3, 4);
            this.set_html(third_series, 3, 7);
            this.set_html(fourth_series, 3, 10);
          } else if ((width >= 1768) && (width < 1815)) {
            first_series = [26, 28, 30, 32];
            second_series = this.getSeries(1768, 2, 3);
            third_series = this.getSeries(1768, 3, 3);
            fourth_series = this.getSeries(1768, 4, 3);

            this.set_html(first_series, 4, 0);
            this.set_html(second_series, 3, 4);
            this.set_html(third_series, 3, 7);
            this.set_html(fourth_series, 3, 10);
          } else if ((width >= 1720) && (width < 1768)) {
            first_series = [24, 26, 28, 30];
            second_series = this.getSeries(1720, 2, 3);
            third_series = this.getSeries(1720, 3, 3);
            fourth_series = this.getSeries(1720, 4, 3);

            this.set_html(first_series, 4, 0);
            this.set_html(second_series, 3, 4);
            this.set_html(third_series, 3, 7);
            this.set_html(fourth_series, 3, 10);
          } else if ((width >= 1673) && (width < 1720)) {
            first_series = [24, 26, 28, 30];
            second_series = this.getSeries(1673, 2, 3);
            third_series = this.getSeries(1673, 3, 3);
            fourth_series = this.getSeries(1673, 4, 3);

            this.set_html(first_series, 4, 0);
            this.set_html(second_series, 3, 4);
            this.set_html(third_series, 3, 7);
            this.set_html(fourth_series, 3, 10);
          } else if ((width >= 1625) && (width < 1673)) {
            first_series = [23, 25, 27, 29];
            second_series = this.getSeries(1625, 2, 3);
            third_series = this.getSeries(1625, 3, 3);
            fourth_series = this.getSeries(1625, 4, 3);

            this.set_html(first_series, 4, 0);
            this.set_html(second_series, 3, 4);
            this.set_html(third_series, 3, 7);
            this.set_html(fourth_series, 3, 10);
          } else if ((width >= 1578) && (width < 1625)) {
            first_series = [23, 25, 27, 29];
            second_series = this.getSeries(1578, 2, 3);
            third_series = this.getSeries(1578, 3, 3);
            fourth_series = this.getSeries(1578, 4, 3);

            this.set_html(first_series, 4, 0);
            this.set_html(second_series, 3, 4);
            this.set_html(third_series, 3, 7);
            this.set_html(fourth_series, 3, 10);
          } else if ((width >= 1530) && (width < 1578)) {
            first_series = [21, 23, 25, 27];
            second_series = this.getSeries(1530, 2, 3);
            third_series = this.getSeries(1530, 3, 3);
            fourth_series = this.getSeries(1530, 4, 3);

            this.set_html(first_series, 4, 0);
            this.set_html(second_series, 3, 4);
            this.set_html(third_series, 3, 7);
            this.set_html(fourth_series, 3, 10);
          } else if ((width >= 1483) && (width < 1530)) {
            first_series = [21, 23, 25, 27];
            second_series = this.getSeries(1483, 2, 3);
            third_series = this.getSeries(1483, 3, 3);
            fourth_series = this.getSeries(1483, 4, 3);

            this.set_html(first_series, 4, 0);
            this.set_html(second_series, 3, 4);
            this.set_html(third_series, 3, 7);
            this.set_html(fourth_series, 3, 10);
          } else if ((width >= 1435) && (width < 1483)) {
            first_series = [20, 22, 24, 26];
            second_series = this.getSeries(1435, 2, 3);
            third_series = this.getSeries(1435, 3, 3);
            fourth_series = this.getSeries(1435, 4, 3);

            this.set_html(first_series, 4, 0);
            this.set_html(second_series, 3, 4);
            this.set_html(third_series, 3, 7);
            this.set_html(fourth_series, 3, 10);
          } else if ((width >= 1388) && (width < 1435)) {
            first_series = [20, 22, 24, 26];
            second_series = this.getSeries(1388, 2, 3);
            third_series = this.getSeries(1388, 3, 3);
            fourth_series = this.getSeries(1388, 4, 3);

            this.set_html(first_series, 4, 0);
            this.set_html(second_series, 3, 4);
            this.set_html(third_series, 3, 7);
            this.set_html(fourth_series, 3, 10);
          } else if ((width >= 1340) && (width < 1388)) {
            first_series = [18, 20, 22, 24];
            second_series = this.getSeries(1340, 2, 3);
            third_series = this.getSeries(1340, 3, 3);
            fourth_series = this.getSeries(1340, 4, 3);

            this.set_html(first_series, 4, 0);
            this.set_html(second_series, 3, 4);
            this.set_html(third_series, 3, 7);
            this.set_html(fourth_series, 3, 10);
          } else if ((width >= 1293) && (width < 1340)) {
            first_series = [18, 20, 22, 24];
            second_series = this.getSeries(1293, 2, 3);
            third_series = this.getSeries(1293, 3, 3);
            fourth_series = this.getSeries(1293, 4, 3);

            this.set_html(first_series, 4, 0);
            this.set_html(second_series, 3, 4);
            this.set_html(third_series, 3, 7);
            this.set_html(fourth_series, 3, 10);
          } else if ((width >= 1245) && (width < 1293)) {
            first_series = [17, 19, 21, 23];
            second_series = this.getSeries(1245, 2, 3);
            third_series = this.getSeries(1245, 3, 3);
            fourth_series = this.getSeries(1245, 4, 3);

            this.set_html(first_series, 4, 0);
            this.set_html(second_series, 3, 4);
            this.set_html(third_series, 3, 7);
            this.set_html(fourth_series, 3, 10);
          } else if ((width >= 1198) && (width < 1245)) {
            first_series = [17, 19, 21, 23];
            second_series = this.getSeries(1198, 2, 3);
            third_series = this.getSeries(1198, 3, 3);
            fourth_series = this.getSeries(1198, 4, 3);

            this.set_html(first_series, 4, 0);
            this.set_html(second_series, 3, 4);
            this.set_html(third_series, 3, 7);
            this.set_html(fourth_series, 3, 10);
          } else if ((width >= 1150) && (width < 1198)) {
            first_series = [15, 17, 19, 21];
            second_series = this.getSeries(1150, 2, 3);
            third_series = this.getSeries(1150, 3, 3);
            fourth_series = this.getSeries(1150, 4, 3);

            this.set_html(first_series, 4, 0);
            this.set_html(second_series, 3, 4);
            this.set_html(third_series, 3, 7);
            this.set_html(fourth_series, 3, 10);
          } else if ((width >= 1103) && (width < 1150)) {
            first_series = [15, 17, 19, 21];
            second_series = this.getSeries(1103, 2, 3);
            third_series = this.getSeries(1103, 3, 3);
            fourth_series = this.getSeries(1103, 4, 3);

            this.set_html(first_series, 4, 0);
            this.set_html(second_series, 3, 4);
            this.set_html(third_series, 3, 7);
            this.set_html(fourth_series, 3, 10);
          } else if ((width >= 1055) && (width < 1103)) {
            first_series = [14, 16, 18, 20];
            second_series = this.getSeries(1055, 2, 3);
            third_series = this.getSeries(1055, 3, 3);
            fourth_series = this.getSeries(1055, 4, 3);

            this.set_html(first_series, 4, 0);
            this.set_html(second_series, 3, 4);
            this.set_html(third_series, 3, 7);
            this.set_html(fourth_series, 3, 10);
          } else if ((width >= 1008) && (width < 1055)) {
            first_series = [13, 15, 17, 19];
            second_series = [35, 36, 46, 47];
            third_series = this.getSeries(1008, 3, 3);
            fourth_series = this.getSeries(1008, 4, 3);

            this.set_html(first_series, 4, 0);
            this.set_html(second_series, 3, 4);
            this.set_html(third_series, 3, 7);
            this.set_html(fourth_series, 3, 10);
          } else if ((width >= 960) && (width < 1008)) {
            first_series = [13, 15, 17, 19];
            second_series = this.getSeries(960, 2, 3);
            third_series = this.getSeries(960, 3, 3);
            fourth_series = this.getSeries(960, 4, 3);

            this.set_html(first_series, 4, 0);
            this.set_html(second_series, 3, 4);
            this.set_html(third_series, 3, 7);
            this.set_html(fourth_series, 3, 10);
          } else if ((width >= 913) && (width < 960)) {
            first_series = [11, 13, 15, 17];
            second_series = this.getSeries(913, 2, 3);
            third_series = this.getSeries(913, 3, 3);
            fourth_series = this.getSeries(913, 4, 3);

            this.set_html(first_series, 4, 0);
            this.set_html(second_series, 3, 4);
            this.set_html(third_series, 3, 7);
            this.set_html(fourth_series, 3, 10);
          } else if ((width >= 865) && (width < 913)) {
            first_series = [11, 13, 15, 17];
            second_series = this.getSeries(865, 2, 3);
            third_series = this.getSeries(865, 3, 3);
            fourth_series = this.getSeries(865, 4, 3);

            this.set_html(first_series, 4, 0);
            this.set_html(second_series, 3, 4);
            this.set_html(third_series, 3, 7);
            this.set_html(fourth_series, 3, 10);
          } else if ((width >= 818) && (width < 865)) {
            first_series = [10, 12, 14, 16];
            second_series = [29, 30, 38, 39];
            third_series = this.getSeries(818, 3, 3);
            fourth_series = this.getSeries(818, 4, 3);

            this.set_html(first_series, 4, 0);
            this.set_html(second_series, 3, 4);
            this.set_html(third_series, 3, 7);
            this.set_html(fourth_series, 3, 10);
          } else if ((width >= 770) && (width < 818)) {
            first_series = [10, 12, 14, 16];
            second_series = this.getSeries(770, 2, 3);
            third_series = this.getSeries(770, 3, 3);
            fourth_series = this.getSeries(770, 4, 3);

            this.set_html(first_series, 4, 0);
            this.set_html(second_series, 3, 4);
            this.set_html(third_series, 3, 7);
            this.set_html(fourth_series, 3, 10);
          } else if ((width >= 710) && (width < 770)) {
            first_series = [10, 12, 14, 16];
            second_series = this.getSeries(710, 2, 3);
            third_series = this.getSeries(710, 3, 3);
            fourth_series = this.getSeries(710, 4, 3);

            this.set_html(first_series, 4, 0);
            this.set_html(second_series, 3, 4);
            this.set_html(third_series, 3, 7);
            this.set_html(fourth_series, 3, 10);
          } else if ((width >= 675) && (width < 710)) {
            first_series = [9, 11, 13, 15];
            second_series = this.getSeries(675, 2, 3);
            third_series = this.getSeries(675, 3, 3);
            fourth_series = this.getSeries(675, 4, 3);

            this.set_html(first_series, 4, 0);
            this.set_html(second_series, 3, 4);
            this.set_html(third_series, 3, 7);
            this.set_html(fourth_series, 3, 10);
          } else if ((width >= 628) && (width < 675)) {
            first_series = [8, 9, 10, 11];
            second_series = this.getSeries(628, 2, 3);
            third_series = this.getSeries(628, 3, 3);
            fourth_series = this.getSeries(628, 4, 3);

            this.set_html(first_series, 4, 0);
            this.set_html(second_series, 3, 4);
            this.set_html(third_series, 3, 7);
            this.set_html(fourth_series, 3, 10);
          } else if ((width >= 580) && (width < 628)) {
            first_series = [8, 9, 10, 11];
            second_series = this.getSeries(580, 2, 3);
            third_series = this.getSeries(580, 3, 3);
            fourth_series = this.getSeries(580, 4, 3);

            this.set_html(first_series, 4, 0);
            this.set_html(second_series, 3, 4);
            this.set_html(third_series, 3, 7);
            this.set_html(fourth_series, 3, 10);
          } else if ((width >= 533) && (width < 580)) {
            first_series = [8, 9, 10, 11];
            second_series = [26, 32, 33, 34];
            third_series = this.getSeries(533, 3, 3);
            fourth_series = this.getSeries(533, 4, 3);

            this.set_html(first_series, 4, 0);
            this.set_html(second_series, 3, 4);
            this.set_html(third_series, 3, 7);
            this.set_html(fourth_series, 3, 10);
          } else if ((width >= 485) && (width < 533)) {
            first_series = [1, 3, 5, 7];
            second_series = [8, 9];
            third_series = this.getSeries(400, 3, 3);
            fourth_series = this.getSeries(400, 4, 3);

            this.set_html(first_series, 4, 0);
            this.set_html(second_series, 3, 4);
            this.set_html(third_series, 3, 7);
            this.set_html(fourth_series, 3, 10);
          } else if ((width >= 390) && (width < 485)) {
            first_series = [2, 4, 5, 7];
            second_series = [10, 11];
            third_series = this.getSeries(300, 3, 3);
            fourth_series = this.getSeries(300, 4, 3);

            this.set_html(first_series, 4, 0);
            this.set_html(second_series, 3, 4);
            this.set_html(third_series, 3, 7);
            this.set_html(fourth_series, 3, 10);
          } else if ((width >= 295) && (width < 390)) {
            first_series = [2, 4, 5, 7];
            second_series = [10, 11];
            third_series = this.getSeries(200, 3, 3);
            fourth_series = this.getSeries(200, 4, 3);

            this.set_html(first_series, 4, 0);
            this.set_html(second_series, 3, 4);
            this.set_html(third_series, 3, 7);
            this.set_html(fourth_series, 3, 10);
          }
      },
      getSeries(width, series_no, no_of_elements) {
        // alert(width);
        // console.log(series_no);
        const height = $(window)
          .height();
        // console.log(height);

        const obj = {};
        // screen 1900 available blocks
        obj.array_1900_1 = [23, 25, 27, 29, 31, 33, 35];
        obj.array_1900_2 = [85, 85, 87, 106];
        obj.array_1900_3 = [99, 93, 95, 114];
        obj.array_1900_4 = [165, 167, 169, 171, 173, 175];

        // screen 1863 available blocks
        obj.array_1863_1 = [25, 27, 29, 31, 33, 35];
        obj.array_1863_2 = [89, 83, 85, 87];
        obj.array_1863_3 = [99, 94, 96, 98];
        obj.array_1863_4 = [145, 147, 149, 151, 153, 155];

        //  screen 1815 available blocks
        obj.array_1815_1 = [24, 26, 28, 30, 32, 34];
        obj.array_1815_2 = [77, 79, 81, 83];
        obj.array_1815_3 = [88, 89, 91, 93];
        obj.array_1815_4 = [138, 140, 142, 144, 146];

        // screen 1768 available blocks
        obj.array_1768_1 = [24, 26, 28, 30, 32, 34];
        obj.array_1768_2 = [77, 79, 81, 83];
        obj.array_1768_3 = [88, 89, 91, 93];
        obj.array_1768_4 = [138, 140, 142, 144, 146];

        // screen 1720 available blocks
        obj.array_1720_1 = [32, 26, 24, 28, 30];
        obj.array_1720_2 = [73, 74, 76, 78];
        obj.array_1720_3 = [83, 84, 86, 88];
        obj.array_1720_4 = [131, 132, 134, 136, 138, 140];

        // screen 1673 available blocks
        obj.array_1673_1 = [21, 22, 24, 26, 28, 30, 32];
        obj.array_1673_2 = [74, 75, 77, 79];
        obj.array_1673_3 = [83, 84, 86, 88];
        obj.array_1673_4 = [130, 131, 133, 135, 137, 139, 141];

        // screen 1625 available blocks
        obj.array_1625_1 = [21, 22, 24, 26, 28, 30];
        obj.array_1625_2 = [69, 70, 72, 74];
        obj.array_1625_3 = [80, 80, 82, 84];
        obj.array_1625_4 = [124, 125, 127, 129, 131, 133];

        // screen 1578 available blocks
        obj.array_1578_1 = [21, 22, 24, 26, 28, 30, 32];
        obj.array_1578_2 = [70, 70, 72, 74];
        obj.array_1578_3 = [79, 80, 82, 84];
        obj.array_1578_4 = [124, 125, 127, 129, 131, 133];

        // screen 1530 available blocks
        obj.array_1530_1 = [20, 21, 23, 25, 27, 29];
        obj.array_1530_2 = [66, 66, 68, 70];
        obj.array_1530_3 = [75, 75, 77, 79];
        obj.array_1530_4 = [116, 117, 119, 121, 123, 125];

        // screen 1483 available blocks
        obj.array_1483_1 = [19, 20, 22, 24, 26, 28];
        obj.array_1483_2 = [70, 70, 68, 66];
        obj.array_1483_3 = [75, 75, 77, 79];
        obj.array_1483_4 = [116, 117, 119, 121, 123, 125];

        // screen 1435 available blocks
        obj.array_1435_1 = [18, 19, 21, 23, 25, 27];
        obj.array_1435_2 = [65, 65, 63, 61];
        obj.array_1435_3 = [71, 71, 73, 75];
        obj.array_1435_4 = [109, 110, 112, 114, 116];

        // screen 1388 available blocks
        obj.array_1388_1 = [18, 19, 21, 23, 25, 27];
        obj.array_1388_2 = [48, 48, 48, 50, 64];
        obj.array_1388_3 = [56, 56, 58, 72];
        obj.array_1388_4 = [94, 95, 97, 99, 101];

        // screen 1340 available blocks
        obj.array_1340_1 = [16, 17, 19, 21, 23, 25];
        obj.array_1340_2 = [42, 45, 47, 60];
        obj.array_1340_3 = [51, 52, 54, 67];
        obj.array_1340_4 = [87, 88, 90, 92, 94];

        // screen 1293 available blocks
        obj.array_1293_1 = [16, 17, 19, 21, 23, 25];
        obj.array_1293_2 = [45, 45, 47, 60];
        obj.array_1293_3 = [52, 52, 54, 67];
        obj.array_1293_4 = [87, 88, 90, 92, 94];

        // screen 1245 available blocks
        obj.array_1245_1 = [16, 17, 19, 21, 23, 25];
        obj.array_1245_2 = [41, 41, 43, 55];
        obj.array_1245_3 = [49, 49, 51, 63];
        obj.array_1245_4 = [81, 82, 84, 86, 88];

        // screen 1198 available blocks
        obj.array_1198_1 = [16, 17, 19, 21, 23];
        obj.array_1198_2 = [41, 41, 43, 55];
        obj.array_1198_3 = [48, 48, 50, 62];
        obj.array_1198_4 = [81, 82, 84, 86, 88];

        // screen 1150 available blocks
        obj.array_1150_1 = [14, 15, 17, 19, 21];
        obj.array_1150_2 = [38, 38, 40, 51];
        obj.array_1150_3 = [45, 45, 47, 58];
        obj.array_1150_4 = [74, 75, 77, 79, 81];

        // screen 1103 available blocks
        obj.array_1103_1 = [14, 15, 17, 19, 21];
        obj.array_1103_2 = [38, 38, 40, 51];
        obj.array_1103_3 = [45, 45, 47, 58];
        obj.array_1103_4 = [74, 75, 77, 79, 81];

        // screen 1055 available blocks
        obj.array_1055_1 = [13, 14, 16, 18, 20];
        obj.array_1055_2 = [35, 35, 37, 47];
        obj.array_1055_3 = [41, 41, 43, 53];
        obj.array_1055_4 = [68, 69, 71, 73, 75];

        // screen 1008 available blocks
        obj.array_1008_1 = [13, 14, 16, 18, 20];
        obj.array_1008_2 = [31, 31, 33, 42];
        obj.array_1008_3 = [55, 41, 43, 53, 42];
        obj.array_1008_4 = [68, 69, 71, 73, 75];

        // 1024X1366(iPad Pro)
        if (height > 768) {
          obj.array_1008_2 = [31, 31, 33, 42];
          obj.array_1008_3 = [64, 65, 75, 76, 77];
          obj.array_1008_4 = [102, 103, 104, 105, 106, 107, 108];
        }

        // screen 960 available blocks
        obj.array_960_1 = [13, 14, 15, 16, 17, 18];
        obj.array_960_2 = [32, 33, 42, 43];
        obj.array_960_3 = [37, 37, 39, 48];
        obj.array_960_4 = [63, 64, 65, 66, 67, 68];

        // screen 913 available blocks
        obj.array_913_1 = [13, 14, 15, 16, 17, 18];
        obj.array_913_2 = [31, 31, 33, 42];
        obj.array_913_3 = [38, 38, 40, 49];
        obj.array_913_4 = [63, 64, 65, 66, 67, 68];

        // screen 865 available blocks
        obj.array_865_1 = [11, 12, 13, 14, 15, 16, 17];
        obj.array_865_2 = [28, 28, 29, 37, 38];
        obj.array_865_3 = [34, 35, 43, 44];
        obj.array_865_4 = [56, 57, 58, 59, 60, 61, 62];

        // screen 818 available blocks
        obj.array_818_1 = [11, 12, 13, 14, 15, 16, 17];
        obj.array_818_2 = [28, 28, 29, 37, 38];
        obj.array_818_3 = [35, 35, 36, 44, 45, 56, 57, 58, 59, 60, 61, 62];
        obj.array_818_4 = [56, 57, 58, 59, 60, 61, 62];

        // screen 770 available blocks
        obj.array_770_1 = [10, 11, 12, 13, 14, 15];
        obj.array_770_2 = [25, 25, 26, 33, 34];
        obj.array_770_3 = [31, 31, 32, 39, 40];
        obj.array_770_4 = [50, 51, 52, 53, 54, 55];
        if (height > 780) {
          obj.array_770_4 = [58, 59, 60, 61, 62, 63];
        }

        // screen 710 available blocks
        obj.array_710_1 = [9, 10, 11, 12, 13];
        obj.array_710_2 = [25, 25, 26, 33, 34];
        obj.array_710_3 = [31, 31, 32, 39, 40];

        if (height > 780) {
          obj.array_710_4 = [58, 59, 60, 61, 62, 63];
        } else {
          obj.array_710_4 = [44, 45, 46, 47, 48];
        }


        // screen 675 available blocks
        obj.array_675_1 = [9, 10, 11, 12, 13];
        obj.array_675_2 = [22, 22, 23, 29, 30];
        obj.array_675_3 = [27, 27, 28, 34, 35, 44, 45, 46, 47, 48];
        obj.array_675_4 = [44, 45, 46, 47, 48];

        // screen 628- available blocks
        obj.array_628_1 = [9, 10, 11, 12, 13];
        obj.array_628_2 = [22, 22, 23, 29, 30];
        obj.array_628_3 = [27, 27, 28, 34, 35, 44, 45, 46, 47, 48];
        obj.array_628_4 = [44, 45, 46, 47, 48];


        // screen 580- available blocks
        obj.array_580_1 = [7, 8, 9, 10, 11, 12];
        obj.array_580_2 = [1, 13, 19, 25, 31];
        obj.array_580_3 = [1, 18, 24, 30, 36, 38, 39, 40, 41, 42];
        obj.array_580_4 = [38, 39, 40, 41, 42];

        // screen 533 available blocks
        obj.array_533_1 = [2, 3, 4, 5, 8, 9, 10, 11];
        obj.array_533_2 = [1, 13, 19, 25, 31];
        obj.array_533_3 = [1, 18, 24, 30, 36, 37, 38, 39, 40, 41, 42];
        obj.array_533_4 = [37, 38, 39, 40, 41, 42];

        // screen 400 available blocks=======================
        obj.array_400_1 = [1, 2, 3, 4, 5, 6, 7, 8];
        obj.array_400_2 = [8, 9, 10, 11, 12];
        obj.array_400_3 = [12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24];
        obj.array_400_4 = [17, 18, 19, 20, 21, 22, 23, 24];

        // screen 300 available blocks
        obj.array_300_1 = [1, 2, 3, 4, 5, 6, 7, 8];
        obj.array_300_2 = [9, 10, 11, 12, 13, 14];
        obj.array_300_3 = [15, 16, 17, 18, 19, 20, 21, 22, 23, 24];
        obj.array_300_4 = [20, 21, 22, 23, 24];

        // screen 200 available blocks
        obj.array_200_1 = [1, 2, 3, 4, 5, 6, 7, 8];
        obj.array_200_2 = [8, 9, 10, 11, 12];
        obj.array_200_3 = [12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24];
        obj.array_200_4 = [17, 18, 19, 20, 21, 22, 23, 24];


        const unique_array = [];
        while (unique_array.length < no_of_elements) {
          const randomnumber = Math.ceil(Math.random() * (obj[`array_${width}_${series_no}`].length - 1));
          if ($.inArray(obj[`array_${width}_${series_no}`][randomnumber], unique_array) == -1) {
            unique_array.push(obj[`array_${width}_${series_no}`][randomnumber]);
            continue;
          }


          if (unique_array.length == no_of_elements) {
            break;
          }
        }

        return unique_array;
      },
    },
  };
</script>
